export const treeselect = {
  root: {
    filledHoverBackground: '{primary.100}',
  },
  dropdown: {
    // width: '2.5rem',
    color: '{neutral.400}',
  },
  colorScheme: {
    light: {
      //   background: '{surface.100}',
      //   color: '{neutral.900}',
      borderColor: '{neutral.200}',
      hoverBorderColor: '{neutral.400}',
      focusBorderColor: '{neutral.400}',
      placeholderColor: '{inputtext.placeholder.color}',
      disabled: {
        background: '{surface.200}',
        color: '{surface.700}',
        borderColor: '{surface.300}',
        opacity: '0.8',
      },
      option: {
        selectedColor: 'black',
      },
      root: {
        // background: '{surface.100}',
        color: 'black',
      },
    },
    dark: {
      background: '#333643',
      color: 'white',
      borderColor: '#5B5F69',
      placeholderColor: '{inputtext.placeholder.color}',
      disabled: {
        background: '#444958ff',
        color: '#5B5F69',
        borderColor: '#5B5F69',
        opacity: '0.8',
      },
      option: {
        color: 'white',
        selectedBackground: '{primary.700}',
        focus: {
          background: '#555B6E',
          selectedBackground: '{primary.400}',
          selectedFocusBackground: '{primary.300}',
          color: 'white',
        },
        selected: {
          color: 'white',
          focus: {
            background: '{primary.700}',
            color: 'white',
          },
        },
      },
      root: {
        // background: '{surface.100}',
        color: 'white',
      },
      overlay: {
        background: 'red',
        color: 'white',
        borderColor: '#5B5F69',
        list: 'white',
      },
    },
  },
};
